import { render, staticRenderFns } from "./Overview2d.vue?vue&type=template&id=6ac095da"
import script from "./Overview2d.vue?vue&type=script&lang=ts"
export * from "./Overview2d.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports